import { render, staticRenderFns } from "./FedrampDashboard.vue?vue&type=template&id=3957f57f&scoped=true&"
import script from "./FedrampDashboard.vue?vue&type=script&lang=js&"
export * from "./FedrampDashboard.vue?vue&type=script&lang=js&"
import style0 from "./FedrampDashboard.vue?vue&type=style&index=0&id=3957f57f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3957f57f",
  null
  
)

export default component.exports